<template>

	<div class="bg">
		<div class="container-fluid">
			<div class="footer">
				<div class="row">
					<div class="col-sm-8">
						<div class="list" v-for="(item,index) in tit" >
							<router-link :to="{path: item.path}" replace>
								<span>{{item.name}}</span>
							</router-link>
						</div>
						<div class="tit tio">营销中心地址：广东省佛山市禅城区南庄镇陶博大道15号金利高陶瓷营销总部（中国） &nbsp;成功热线：0757-8992 5781</div>
						<div class="tit">C0PYright (c) 2017 All Rights Reserved 版权所有(C)佛山市金利高陶瓷有限公司 版权所有</div>
						<div class="tit">粤IP备17080232号-1</div>
					</div>
					<div class="col-sm-4">
						<div class="row">
							<div class="col">
								<img src="../../../static/images/ma.png" />
								<p>扫一扫关注微信公众号</p>
							</div>
							<div class="col">
								<img src="../../../static/images/ma.png" />
								<p>扫一扫关注APP</p>
							</div>
							<div class="col"><img src="../../../static/images/ma.png" />
								<p>扫一扫关注小程序</p> 
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				tit: [{
						name: "首页",
						path: '/'
					},
					{
						name: "新闻资讯",
						path: '/news'
					},
					{
						name: "产品中心",
						path: '/product'
					},
					{
						name: "招商加盟",
						path: '/join'
					},
					{
						name: "关于我们",
						path: '/about'
					},
				]
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {

		},
	}
</script>

<style scoped lang="less">
	@w: 19.2vw;
	.footer {
		font-size: 18/@w;
		color: #FBF4E9;
	}
	
	.bg {
		background: url("../../../static/images/footerBg.png") no-repeat center;
		background-size: 100% 100%;
		overflow: hidden;
		padding: 40/@w 100/@w 200/@w 100/@w;
		box-sizing: border-box;
	}
	
	img {
		width: 120/@w;
		min-width: 50px;
		display: block;
		margin: 0 auto;
	}
	
	.list {
		display: inline-block;
		a{
			color:#FBF4E9;
		}
		a:hover{
			color: #166BAB;
			font-weight: bold;
		}
		span {
			display: inline-block;
			border-right: 1px solid #FBF4E9;
			padding: 0 30/@w;
		}
	}
	
	.tit {
		padding-top: 27/@w;
		&:nth-last-child(1) {
			padding-bottom: 27/@w;
		}
	}
	
	.tio {
		padding-top: 40/@w;
	}
	
	p {
		font: 18/@w;
		color: #FBF4E9;
		margin-top: 4px;
		text-align: center;
	}
	
	@media screen and (max-width: 768px) {
		ul {
			li {
				width: 80px;
				margin-top: 10px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/comFooter/index.vue